import {hasAdminRole } from "./api-account";

export const DATA_REFRESH_TIME: number = 30000;

// AUTHENTICATION ///////////////////////////
export interface LogInResponse {
    token: string;
    expires: Date;
}

export interface userInfo {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    distributorId: number | null;
    distributorName: string | null;
    customerId: number | null;
    customerName: string | null;
    roles: string[];
}

export interface registerUserInfo {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    distributorId: number | null;
    customerId: number | null;
    roles: string[];
}

export interface ChangePassword {
    email: string;
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export interface LoginAttempt {
    email: string;
    password: string;
}

export interface SetPassword {
    email: string;
    password: string;
    confirmPassword: string;
    code: string;
}

export interface PasswordResponse {
    message: string;
}

export interface ConfirmAccount {
    email: string,
    password: string,
    password2: string,
    token: string
}

// Component Functions //////////////////////////////

export interface DropdownList {
    value: number;
    name: string;
}


// Enums //////////////////////////////////
export enum alarmSeverity {
    "Note" = 1,
    "Not Act + Ack'd" = 2,
    "Not Active" = 3,
    "Warning" = 4,
    "Active + Ack'd" = 5,
    "Active" = 6,
    "Critical" = 7,
}

export enum alarmSeverityColors {
    'empty' = 1,
    'clear' = 2,
    'green' = 3,
    'gold' = 4,
    'orange' = 5,
    'red' = 6,
    'crimson' = 7,
}

export enum orgTypes {
    'Not Selected',
    'Customer',
    'Distributor',
    //'Admin',
}

export const GetOrgTypeDropdownList = (): DropdownList[] => {
    if(hasAdminRole()){
        return [
            { name: orgTypes[orgTypes["Not Selected"]], value: orgTypes["Not Selected"] },
            { name: orgTypes[orgTypes.Customer], value: orgTypes.Customer },
            { name: orgTypes[orgTypes.Distributor], value: orgTypes.Distributor },
            //{ name: orgTypes[orgTypes.Admin], value: orgTypes.Admin }
        ];
    }else{
        return [
            { name: orgTypes[orgTypes["Not Selected"]], value: orgTypes["Not Selected"] },
            { name: orgTypes[orgTypes.Customer], value: orgTypes.Customer }
        ];
    }
}

export interface orgDetails {
    name: string;
    id: number | null;
    orgType: orgTypes;
    distId: number | null;
}

// This isn't an interface so that we can have a getter to return the OrgType
// as a string
export class orgInfo {

    // Constructor type method. Needed so all the properties are 
    // correct, and to register the getter
    Init(o: orgDetails) {
        this.name = o.name;
        this.distId = o.distId;
        this.orgType = o.orgType;
        this.id = o.id;
    }

    name: string = '';
    id: number | null = null;
    orgType: orgTypes = orgTypes["Not Selected"];
    distId: number | null = null;

    public get test(): string {
        return orgTypes[this.orgType];
    }
}

export enum cutStatus {
    "Completed" = 0,
    "Abandoned" = 1,
    "Other" = 2,
}

// Customer Datas ///////////////////////
export interface Alarm {
    systemId: number;
    systemName: string;
    raisedTime: Date;
    ackTime: Date | null;
    isActive: boolean;
    message: string;
    severity: alarmSeverity;
}

export interface reportRequest {
    startDate: Date,
    endDate: Date,
    systemId: number,
    org: number,
    shiftStartTime?: Date | null,
    shiftEndTime?: Date | null,
}

export interface ReportHistory {
    systemName: string,
    userId: number,
    startTime: Date;
    endTime: Date;
    reqCutLength: number;
    actualCutLength: number;
    status: cutStatus;
    presetNumber: number;
}

export interface Winder {
    id:number;
    name:string;
    location:string;
    ownerName:string;
    mode:string;
    currentCutRequest:number|null;
    heartBeat:Date|null;
    serialNumber:string;
    mqttPassword:string;
    macAddress:string;
}

export interface createWinder {
    name:string;
    location:string;
    serialNumber:string;
    customerId:number|null;
    distributorId:number|null;
    macAddress:string;
}

export interface editWinder {
    id:number;
    name:string;
    location:string;
    serialNumber:string;
    mqttPassword:string;
    customerId:number|null;
    distributorId:number|null;
    macAddress:string;
}

export interface presetInfo {
    id:number;
    winderId:number;
    preset1:number;
    preset2:number;
    preset3:number;
    preset4:number;
    preset5:number;
    preset6:number;
    preset7:number;
    preset8:number;
}
// /api/org
export interface distributor {
    id: number;
    name: string;
}

export interface customerInfo {
    id: number;
    name: string;
    distributorID: string;
}

export interface OEEHistory {
    startTime: Date;
    endTime: Date;
    runTime: number;
    idleTime: number;
    cycleCount: number;
    cutLengthTotal: number;
}




export interface customerInfo {
    name: string;
    id: number;
    phone: string;
    email: string;
    orgID: number;
    masterOrgName: string;
    companyID: string;
}

export interface customerUpdate {
    orgId: number,
    name: string,
    primaryContactId: string,
    masterCustomerID?: number,
    companyID: string
}

// Default Datas ///////////////////////////////////////////

export const getDefaultUserInfo = (): userInfo => {
    return {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        roles: ["Customer"],
        distributorId: null,
        distributorName: null,
        customerId: null,
        customerName: null,
    }
}

export const GetDefaultWinder = (): Winder => {
    return {
        id:0,
        name:"",
        location:"",
        ownerName: "",
        mode:"",
        currentCutRequest:null,
        heartBeat: new Date(1999,1,1,0,0,0),
        serialNumber:"",
        mqttPassword:"",
        macAddress:"",
    }
}